<template>
  <Transition appear name="primary-modal">
    <div :class="isLightMode() ? 'primary-modal' : 'primary-modal-dark'" @click.self="onClickModalBackground">
      <div :class="isLightMode() ? 'primary-modal-window' : 'primary-modal-dark-window'">
        <header class="primary-modal-header">
          <slot name="header" />
        </header>
        <div class="primary-modal-content">
          <slot />
        </div>
        <footer class="primary-modal-footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts">
import { defineComponent, SetupContext } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
export default defineComponent({
  setup(props, ctx: SetupContext) {
    const { isLightMode } = useConfigStatePresenter()

    const onClickModalBackground = () => {
      ctx.emit('clickBackground')
    }

    return { isLightMode, onClickModalBackground }
  }
})
</script>

<style lang="postcss" scoped>
.primary-modal {
  @apply flex items-center justify-center fixed z-50 top-0 left-0 w-full h-full;
  background: rgba(0, 0, 0, 0.5);
}

.primary-modal-window {
  @apply bg-white overflow-x-hidden overflow-y-hidden;
  border-radius: 0.75rem;
}

.primary-modal-dark {
  @apply flex items-center justify-center fixed z-50 top-0 left-0 w-full h-full;
  background: rgba(0, 0, 0, 0.8);
}

.primary-modal-dark-window {
  @apply bg-dark-900 overflow-x-hidden overflow-y-hidden border border-dark-400;
  border-radius: 0.75rem;
}

/* transition */
.primary-modal-enter-active,
.primary-modal-leave-active {
  transition: opacity 1s;
  .primary-modal-window {
    transition: opacity 1s transform 0s;
  }
}

.primary-modal-enter-from,
.primary-modal-leave-to {
  opacity: 0;
  .primary-modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
